/**
 *
 * Card
 *
 */

import React, { forwardRef } from 'react';
import ClassNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  root: {
    breakInside: 'avoid',
    position: 'relative',
  },
  linkRoot: {
    marginBottom: 8,
  },
  fullHeight: {
    height: '100%',
  },
  wrapper: props => ({
    overflow: 'hidden',
    boxShadow: 'none !important',
    borderRadius: `${props.borderRadius}px !important`,
    border: `1px solid ${props.borderColor}`,
    padding: props.padding || props.padding === 0 ? `${props.padding}px` : 10,
    textAlign: 'center',
    height:
      props.height === '100%'
        ? '100%'
        : props.height
        ? `${props.height}px`
        : 'auto',
    width: props.width ? props.width : 'auto',
    backgroundColor: props.background ? props.background : '#fff',
    marginBottom: props.mb,
  }),
  centeredContent: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  noBorder: {
    border: 'none',
  },
});
const Card = forwardRef((props, ref) => {
  const classes = useStyles(props);

  const {
    borderColor,
    centered,
    children,
    fullHeight,
    link,
    className,
  } = props;

  return (
    <Box
      id={props.id}
      className={ClassNames(
        classes.root,
        {
          [classes.linkRoot]: link,
          [classes.fullHeight]: fullHeight,
        },
        className,
      )}
      ref={ref}
    >
      <Paper
        className={ClassNames(classes.wrapper, {
          [classes.centeredContent]: centered,
          [classes.noBorder]: borderColor === 'transparent',
        })}
      >
        {children}
      </Paper>
    </Box>
  );
});

Card.defaultProps = {
  borderColor: '#cccccc',
  borderRadius: 0,
  mb: 0,
};

export default React.memo(Card);
